import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import VariableSalaryModalBase from "../VariableSalaryModalBase.vue";
import priceFormatter from "@/utility/priceFormatter";
import Absence from "../Absence.vue";
import DirectorCalculationBasis from "./DirectorCalculationBasis.vue";
import DirectorCalculationEquaction from "./DirectorCalculationEquaction.vue";
export default Vue.extend({
    props: {
        selectedDate: String,
        salaryRow: {},
        salaryRowDetails: {},
    },
    components: {
        VariableSalaryModalBase,
        DirectorCalculationBasis,
        DirectorCalculationEquaction,
        Absence,
    },
    filters: {
        numberToSek(number) {
            return priceFormatter.fromNumber(number).toStringSEK();
        },
    },
    computed: {
        ...mapGetters("variableSalaryModal", ["hoveredVariable"]),
        variableSalaryClass() {
            const base = ["math-text", "h1", "cursor-default"];
            if (this.hoveredVariable === "Variable salary") {
                base.push("hovered");
            }
            return base;
        },
    },
    methods: {
        ...mapActions("variableSalaryModal", ["setHoveredVariable"]),
        hoveredClass(target) {
            if (target === this.hoveredVariable) {
                return "hovered";
            }
        },
    },
});
